export default function Loading() {
    return (
        <p style={{ textAlign: "center" }}>
            <b>Loading...</b>
        </p>
    );
}